module.exports = __webpack_public_path__ + "media/images/it/icons/research-0716fb6eb3c0bf6a159b95792d85d7b7.svg";